import { createSlice } from "@reduxjs/toolkit";
import { exportData } from "../../actions/dataTable/DataFiltersAsyncActions";
import { logOut } from "../layout";

export type columnsToExportType = {
  name: string;
  localizedName: string;
  columnType: string;
  hidden: boolean;
  hideable: boolean;
  alwaysHide: boolean;
  useShortResult: boolean;
};
export interface DataExportState {
  loadingExport: boolean;
  exportModalVisible: boolean;
  typeOfExport: string;
  successExport: boolean;
  errorExport: string;
  email: string;
  filtersToExport: {
    datesRange: {
      fromDate: Date;
      toDate: Date;
    };
    cropsTextIds: number[];
    scenarioNamesTextIds: number[];
    usernames: string[];
    geoPointNames: string[];
  };

  columnsToExport: columnsToExportType[];
}

export const initialState: DataExportState = {
  loadingExport: false,
  exportModalVisible: false,
  typeOfExport: "",
  successExport: false,
  errorExport: "",
  email: "",
  filtersToExport: {
    datesRange: {
      fromDate: new Date(new Date().setDate(new Date().getDate() - 7)),
      toDate: new Date(new Date().setDate(new Date().getDate())),
    },
    cropsTextIds: [],
    scenarioNamesTextIds: [],
    usernames: [],
    geoPointNames: [],
  },
  columnsToExport: [],
};

export const dataExportSlice = createSlice({
  name: "dataExport",
  initialState,
  reducers: {
    setColumnsToExport: (state, action) => {
      state.columnsToExport = action.payload.columnsToExport;
      state.filtersToExport = action.payload.filtersToExport;
    },
    setEmailExport: (state, action) => {
      state.email = action.payload;
    },

    setTypeOfExportSelected: (state, action) => {
      state.typeOfExport = action.payload;
    },
    setLoadingExport: (state, action) => {
      state.loadingExport = action.payload;
    },
    setExportModalVisible: (state, action) => {
      state.exportModalVisible = action.payload;
    },

    resetExportState: () => {
      return initialState;
    },
  },

  extraReducers(builder) {
    builder.addCase(exportData.pending, (state) => {
      state.successExport = false;
      state.loadingExport = true;
      state.errorExport = "";
    });
    builder.addCase(exportData.fulfilled, (state) => {
      state.loadingExport = false;
      state.successExport = true;
      state.errorExport = "";
    });

    builder.addCase(exportData.rejected, (state, action) => {
      state.loadingExport = false;
      state.successExport = false;

      state.errorExport = action.payload as string;
      setTimeout(() => {
        state.errorExport = "";
      }, 5000);
    });

    builder.addCase(logOut, () => {
      return initialState;
    });
  },
});

export const {
  setColumnsToExport,
  setEmailExport,
  resetExportState,
  setLoadingExport,
  setExportModalVisible,
  setTypeOfExportSelected,
} = dataExportSlice.actions;

export const DataExportReducer = dataExportSlice.reducer;
